import cn from 'classnames';
import { MdCircle } from 'react-icons/md';
import { Skeleton, TmdxAvatar } from '@ds';
import { getCaseLogUserName } from '@features/components/CaseOverview/components/CaseLogTab/utils';
import { Case, CaseLog } from '@/api/apis/case';
import { CASE_LOG_GROUP_ICON, formatDate, getColorsByOrganType } from '@/utils/helpers';
import { caseLogGroupNames, caseLogEventToGroupMap } from '@/constants/case/case.constants';
import { CaseLogCardContent } from './CaseLogCardContent';

type CaseLogCardProps = {
  caseData: Case;
  data: CaseLog;
};

export const CaseLogCard = ({ data, caseData }: CaseLogCardProps) => {
  const { userName, fullName } = getCaseLogUserName(data.user, data.userId); // TODO: For CaseTxCenterDraftCreated it is TX Center instead of User
  const colors = getColorsByOrganType(caseData.organType);
  const caseLogGroup = caseLogEventToGroupMap[data.eventType];

  const CaseLogGroupIcon = CASE_LOG_GROUP_ICON[caseLogGroup];

  return (
    <div className="grid grid-cols-[64px_1fr] items-center rounded-lg bg-base-80">
      <div className={cn('flex items-start justify-center h-full', colors.bg70)}>
        <div className="flex items-center justify-center">
          <CaseLogGroupIcon className="text-base-50 size-10 mix-blend-multiply" />
        </div>
      </div>
      <div className="flex flex-col gap-1 px-4 py-2 flex-1 truncate">
        <div className="flex items-center">
          <div className="flex items-center gap-1">
            <TmdxAvatar size="sm" radius="sm" name={fullName} src={data.user?.profilePhoto} />
            <span className="text-s-m text-base-5 truncate">{userName}</span>
          </div>
          <MdCircle className="mx-1.5 text-base-10" size={4} />
          <span className={cn('text-s-m', colors.textSaturated)}>{caseLogGroupNames[caseLogGroup]}</span>
          <MdCircle className="mx-1.5 text-base-10" size={4} />
          <span className="text-s-r text-base-20">{formatDate(data.createdAt, 'MMM do, yyyy HH:mm zzz')}</span>
        </div>
        <CaseLogCardContent log={data} caseData={caseData} />
      </div>
    </div>
  );
};

CaseLogCard.Skeleton = () => (
  <div className="flex items-center gap-4 rounded-lg bg-base-80 overflow-hidden">
    <div className="flex items-center justify-center size-16 bg-base-60">
      <Skeleton className="flex rounded-full w-8 h-8" />
    </div>
    <div className="flex flex-col gap-1 w-2/5">
      <div className="flex items-center h-5 gap-2">
        <div className="flex items-center gap-1 w-3/5">
          <Skeleton className="flex shrink-0 rounded-full w-4 h-4" />
          <Skeleton className="h-3 w-full rounded-lg" />
        </div>
        <Skeleton className="h-3 w-2/5 rounded-lg" />
        <Skeleton className="h-3 w-2/4 rounded-lg" />
      </div>
      <div className="flex items-center gap-2 w-4/5">
        <Skeleton className="h-4 w-3/5 rounded-lg" />
        <Skeleton className="h-4 w-2/5 rounded-lg" />
      </div>
    </div>
  </div>
);
